import React, { useEffect, useMemo, useState } from "react";
import {
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import { SideNav } from "components";
import OptionSelection from "components/Flex/OptionSelection";
import http from "services/httpService";
import useFlex from "hooks/useFlex";
import CardSelector from "components/CardSelector";
import { Chip } from "@mui/material";
import { colors } from "theme";

const Benefits = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [pickVoluntary, setPickVoluntary] = useState(false);
  const [productList, setProductList] = useState([]);
  const [mandatoryPicked, setMandatoryPicked] = useState(false);
  const [selectedMandatory, setSelectedMandatory] = useState(new Set());
  const [selectedVoluntary, setSelectedVoluntary] = useState(new Set());
  const { next, resetCompletedProductList, setupListener } = useFlex();

  useEffect(() => {
    setupListener();
    (async function () {
      resetCompletedProductList(); // resetting completed product list
      await getProductList();
    })();
  }, []);

  // getting list of products (display_name, value)
  const getProductList = async () => {
    try {
      const { data } = await http.get("business/get_flex_products/");
      localStorage.setItem("product_list", JSON.stringify(data));
      setProductList(data);
    } catch (err) {
      alert("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };


  // handling option selection
  const optionHandler = (value, list, set) => {
    const newSet = new Set(list);
    if (list.has(value)) {
      newSet.delete(value);
      set(newSet);
    } else {
      newSet.add(value);
      set(newSet);
    }
  };

  const submitHandler = () => {
    if(!mandatoryPicked) {
      setMandatoryPicked(true);
    }
    // if(!selectedMandatory.size) {
    //   alert("Please select atleast one mandatory product");
    //   return;
    // }
    if (!pickVoluntary) {
      setPickVoluntary(true);
      return;
    }

    const selectedProductList = []; // creating a list of selected products
    const isEmpty = !selectedMandatory.size; // making sure list is not empty
    // if (isEmpty) {
    //   alert("Please select atleast one product");
    //   return;
    // }
    productList.forEach((product, index) => {
      // storing selected product value and selected option index
      if(selectedMandatory.has(product.value)) {
        selectedProductList.push({
          product: product.value,
          option: 0,
        })
      }
      if(selectedVoluntary.has(product.value)) {
        selectedProductList.push({
          product: product.value,
          option: 1,
        })
      }
    });
    const sortedProductList = selectedProductList.sort((a, b) => a.option - b.option);
    localStorage.setItem(
      "selected_product_list",
      JSON.stringify(sortedProductList)
    );
    next();
  };

  const getProductName = (value) => {
    const product = productList.find((product) => product.value === value);
    return product.display_name;
  };

  const selectedMandatoryDetailsArray = useMemo(() => {
    return productList.filter(
      (product) => !selectedMandatory.has(product.value)
    );
  }, [productList, selectedMandatory]);

  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <section>
          <SideNav />
          <MainBody>
            <PageTitle title="Select Benefits" />
            <section>
              <Ptag fontSize="16px" fontWeight="600">
                {`${pickVoluntary ? 'Selected ' : ''}Mandatory Benefits`}
              </Ptag>
              <div style={{ marginTop: "24px", maxWidth: "800px" }}>
                {!pickVoluntary ? (
                  <CardSelector
                    list={productList}
                    selected={selectedMandatory}
                    onChange={(val) =>
                      optionHandler(
                        val,
                        selectedMandatory,
                        setSelectedMandatory
                      )
                    }
                  />
                ) : (
                  <div
                    style={{ display: "flex", gap: "2rem", flexWrap: "wrap" }}
                  >
                    {Array.from(selectedMandatory).map((option) => (
                      <Chip
                        label={getProductName(option)}
                        color="primary"
                        sx={{
                          fontSize: "14px",
                          padding: "2rem",
                          fontFamily: "Inter",
                          backgroundColor: "#D7E9FF",
                          color: colors.primaryColor,
                          borderRadius: "8px",
                        }}
                      />
                    ))}
                  </div>
                )}
                {selectedMandatory.size === 0 && mandatoryPicked && (
                  <Ptag marginTop="-10px"><i>None</i></Ptag>
                )}
                {pickVoluntary && selectedMandatoryDetailsArray.length > 0 && (
                  <section>
                    <Ptag
                      marginTop="4rem"
                      fontSize="16px"
                      fontWeight="600"
                    >
                      Voluntary Benefits
                    </Ptag>
                    <div style={{ marginTop: "2rem" }}>
                      <CardSelector
                        list={selectedMandatoryDetailsArray}
                        selected={selectedVoluntary}
                        onChange={(val) =>
                          optionHandler(
                            val,
                            selectedVoluntary,
                            setSelectedVoluntary
                          )
                        }
                      />
                    </div>
                  </section>
                )}
              </div>
            </section>
            <footer
              style={{
                maxWidth: "800px",
                marginTop: "6rem",
                position: "absolute",
                width: "100%",
                bottom: "4rem",
              }}
            >
              <LargeButton
                onClick={submitHandler}
                label="Save & Next"
                style={{ padding: "18px 0px" }}
              />
            </footer>
          </MainBody>
        </section>
      )}
    </>
  );
};

export default Benefits;
